import React from "react";
import { Remarkable } from "remarkable";

const markdown = new Remarkable({
  html: true,
  breaks: true
});

const ImageTextFlexAlign = ({ content }) => {
  const { header, description, image, align } = content;
  return (
    <div id="ImageTextFlexAlign">
      <div className="wrap" style={{ "--main-align": align === "left" ? "row" : "row-reverse" }}>
        <div className="photo">
          <img src={image.url} alt="" style={{ "--photo-align-mobile": align }} />
        </div>
        <div className="contentContainer">
          <div className="header">{header}</div>
          <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
        </div>
      </div>
    </div>
  );
};

export default ImageTextFlexAlign;
